export default {
    DOM: {
        CHANGED: {}  /* Wird wenn das Event 'DOMContentLoaded' auftritt ausgelöst.
                     * Dieses Event bitte auslösen, wenn sich der DOM ändert.
                     * - 'element': Element, das alle Elemente enthält, die sich womöglich geändert haben könnten. Ist beim initialen Seitenaufruf 'document.body'.
                     */
    },
    HISTORY: {      /* history:{token}`: Wird beim Löschen des History-States mit dem Token `token` ausgelöst.
                     * {token} ist hierbei variabel/kann unterschiedlich sein.
                     */
        BACK: {},   /* history:back`: Wird bei der Änderung des aktiven History-States ausgelöst.
                     * Z.B. beim Benutzen des "Zurück"-Buttons im Browser.
                     */
        STATE: {}
    },
    NAVIGATION_ACCORDION: {
        OPENED: {}, /* Wird beim Öffnen der kleinen Navigation ausgelöst. */
        CLOSED: {},  /* Wird beim Schließen der kleinen Navigation ausgelöst. */
        RENDERED: {}
    },
    SWIPER: {
        AJAX_CONTENT_LOADED: {} /* Wird ausgelöst, wenn der Swiper Content-Daten per Ajax erhalten hat und mit diesen
                                 * seine Inhaltsbereiche aktualisiert hat
                                 * - {"newDataAdded": Boolean} Flag, die angibt, ob neue Daten für den Swiper gerendert wurden
                                 */
    },
    CART: {
        ITEM_ADD_SUCCESS: {},   /* Wird ausgelöst, wenn ein Artikel in den Warenkorb gelegt wird.
                                 * - {"wishlistItemId": Integer (optional)} Falls der Artikel aus der Wunschliste kam, steht hier die ID dieses Wunschlisteneintrags
                                 */
        ITEM_DELETED: {},  // Wird ausgelöst, wenn ein Artikel aus dem Warenkorb entfernt wird.
        SIZE_ERROR: {},     // Wird ausgelöst, wenn keine Größe ausgewählt ist.
        ITEM_CHANGE_SUCCESS: {}, // Wird ausgelöst, wenn das Ändern eines Artikel aus dem Warenkorb erfolgreich war.
        ITEM_CHANGE_ERROR: {}, // Wird ausgelöst, wenn das Ändern eines Artikel aus dem Warenkorb nicht erfolgreich war.
        OPENED: {} // Wird ausgelöst, wenn Warenkorbseite angezeigt wird
    },
    OPTIN: {
        MARKETING_STATUS_CHANGED: {}, // Wird ausgelöst, wenn Marketing-OptIn via Permission-Element verändert wurde
        ANALYTICS_STATUS_CHANGED: {},  // Wird ausgelöst, wenn Analytics-OptIn via Permission-Element verändert wurde
        COMPLETE_CONSENT_GIVEN: {}  // Wird ausgelöst, wenn zu allen Kategorien via Permission-Element zugestimmt wurde
    },
    NITRO: {
        LOADED:{} // Wird ausgelöst, wenn Nitro geladen wurde
    },
    WISHLIST: {
        ITEM_ADD: {},   /* Benachrichtigt darüber, dass ein Artikel in die Wunschliste gelegt werden soll
                         * - {
                         *      "articleNumber": Integer (optional),    // Artikelnummer
                         *      "shopId": Integer,                      // Id des Shops aus dem der Artikel stammt
                         *      "digistyleId": Integer,                 // Digistyle-ID des Artikels
                         *      "itemId": Integer,                      // Item-ID (bspw. Farbe) des Artikels
                         *      "itemOptionId": Integer (optional),     // Itemoption-ID (bspw. Größe) des Artikels
                         *   }
                         */
        ITEM_DELETE: {},   /* Benachrichtigt darüber, dass ein Artikel aus der Wunschliste gelöscht werden soll
                         * - {
                         *      "digistyleId": Integer,                 // Digistyle-ID des Artikels
                         *   }
                         */
        ITEM_DELETED: {}, /* Wird ausgelöst, wenn ein Wunschlisten-Eintrag aus der Wunschliste gelöscht wird.
                         * - {
                         *      "currentItemsInWishlist": Integer (optional),      // Aktuelle Anzahl der Wunschlisteneinträge
                         *      "digistyleId": Integer (optional)                  // Digistyle-ID des Artikels
                         *   }
                         */
        ITEM_ADDED: {}, /* Wird ausgelöst, wenn ein Wunschlisten-Eintrag in die Wunschliste hinzugefügt wird.
                         * - {
                         *      "amountAdded": Integer,                  // Anzahl hinzugekommener Items
                         *      "digistyleId": Integer,                  // DigistyleId des hinzugefügten Artikels
                         *    }
                         */
        OPEN_CHANGE_ITEM_ONSITE_ELEMENT: {}, /* Wird ausgelöst, wenn das Change-Item-Onsite-Element aufgerufen werden soll
                                               * - {
                                               *        "type": ["cart", "change"], // Bestimmt den Typ des Submit Buttons im Onsite Element
                                               *        "styleId": Integer,      // DigistyleID (grob: Variante) des zu editierenden Produkts
                                               *        "itemId": Integer,       // ItemID (Farbe) des zu editierenden Produkts
                                               *        "itemOptionId": Integer, // ItemOptionID (Größe) des zu editierenden Produkts
                                               *        "shopId": Integer,       // ShopID des zu editierenden Produkts
                                               *        "wishlistItemId": Integer, // Wishlist Item ID des zu editierenden Eintrags
                                               *        "wishlistItem": Element, // Wishlist-Item, das angeklickt wurde
                                               *        "wishlistItemIndex": Integer, // Index des Wishlist-Items in der Liste
                                               *   }
                                               */
        CLOSE_CHANGE_ITEM_ONSITE_ELEMENT: {},
        OPENED: {}, /* Wird ausgelöst, wenn die Wishlist-Seite geöffnet wird.
                     * - {
                     *      "screenWidth": 	Long,       // orizontale Auflösung des Kundenbildschirms
                     *      "screenHeight": Long,       // Vertikale Auflösung des Kundenbildschirms
                     *      "windowHeight": Long,       // Sichtbare, horizontale Höhe des Kundenbrowsers
                     *      "windowWidth": Long,        // Sichtbare, horizontale Breite des Kundenbrowsers
                     *      "tabId": String.            // aktuelle UUID des Browsertabs
                     *      "breadcrumbs": String,      // Oben sichtbare Navigationstiefe
                     *      "pageTitle": String,        // Namen des Tabs
                     *      "userAgent": String,        // userAgent
                     *      "url": String,              // Aktuelle, komplette URL
                     *      "referrer": String,         // Inhalt des referrer headers falls vorhanden
                     *      "shopVersion": String,      //Commit Tag der aktuellen Revision des Shops
                     *      "pageType": String          //
                     * }
                     */
        SHOW_ERROR_LAYER: {}, /* Wird ausgelöst, wenn es einen Fehler beim Hinzufügen zur oder Löschen aus der Wunschliste gab, um dies bei der Kundin zu kommunizieren
                    * - {
                    *        "error": ["FULL", "ERROR", "DUPLICATE", "REMOVE"]     // Fehlertyp
                    *   }
                    */
    },
    CHANNEL: {
        OPENED: {} /* Wird ausgelöst, wenn eine Channel-Seite geöffnet wird.
                     * - {
                     *      "screenWidth": 	Long,       // orizontale Auflösung des Kundenbildschirms
                     *      "screenHeight": Long,       // Vertikale Auflösung des Kundenbildschirms
                     *      "windowHeight": Long,       // Sichtbare, horizontale Höhe des Kundenbrowsers
                     *      "windowWidth": Long,        // Sichtbare, horizontale Breite des Kundenbrowsers
                     *      "tabId": String.            // aktuelle UUID des Browsertabs
                     *      "breadcrumbs": String,      // Oben sichtbare Navigationstiefe
                     *      "pageTitle": String,        // Namen des Tabs
                     *      "userAgent": String,        // userAgent
                     *      "url": String,              // Aktuelle, komplette URL
                     *      "newPageView": boolean,     // Hat der Kunde die Seite in der Session zum ersten mal aufgerufen?
                     *      "referrer": String,         // Inhalt des referrer headers falls vorhanden
                     *      "shopVersion": String,      // Commit Tag der aktuellen Revision des Shops
                     *      "pageType": String          //
                     * }
                     */
    },
    WINDOW: {
        ORIENTATION_CHANGED: {},
        SCALED: {} /* Wird ausgelöst, wenn auf einem Mobilgerät gezoomed wird.
                    * - {
                        scale: Number, // Neuer Zoomfaktor
                        previousScale: Number, // Vorheriger Zoomfaktor
                        offsetTop: Number // Y-Position auf der Seite der oberen Viewport-Kante
                    }
                    */
    },
    GLOBAL_ERROR: {
        SHOW: {}        /* Wird ausgelöst, wenn eine globale Fehlermeldung angezeigt werden soll. */
    },
    LAYER: {
        OPEN: {}, /* Event kann geworfen werden, um ein Layer erneut zu öffnen */
        CLOSE_ALL_VISIBLE: {},   /* Event kann geworfen werden um offene Layer zu schließen */
        CHANGE_ITEM_PREPARE_TO_OPEN: {}, /* Event wird geworfen, sobald change layer geöffnet werden soll (es kommt dann noch zu einem
                                          * Delay, weil Produktdaten geladen werden müssen) */
        CHANGE_ITEM_LAYER_DATA: {},     /* Event wird geworfen, wenn Daten für den Ändern-Layer erhalten wurden */
        CHANGE_ITEM_LAYER_OPENED: {},   /* Event wird geworfen, wenn der Ändern-Layer geöffnet wird
                                        * - {
                                        *      "digistyleId": Integer // Digistyle-ID des Artikels auf dem Layer
                                        *   }
                                        */
        CHANGE_ITEM_ONSITE_OPENED: {},  /* Event wird geworfen ,wenn das Ändern-Onsite-Element geöffnet wird
                                        * - {
                                        *      "digistyleId": Integer // Digistyle-ID des Artikels auf dem Layer
                                        *   }
                                        */
        CHANGE_ITEM_OPENED_REGISTERED: {},
        CHANGE_ITEM_CHANGE_STYLE: {},
        CHANGE_ITEM_CHANGE_COLOR: {},
        CHANGE_ITEM_SUBMIT: {},
        CHANGE_ITEM_AVAILABILITY_REMINDER: {},
        PICK_UP_LOCATION_SEARCH_TERM: {},
    },
    APP_BANNER: {
        CLOSE: {}
    },
    ADP: {
        OPENED: {}
    },
    ARTICLE_OVERVIEW: {

        ARTICLE_RELOAD_ERROR: {},

        SORTING_CHANGE: {},

        ALL_CONTENT_RELOAD_ERROR: {},

        CHUNK_RELOADED: {},

        RELOADING_ACTIVATE_LOADER: {},

        MODEL_UPDATE: {},

        ALPIS_RELOAD: {},

        ALPIS_RELOADED: {},

        ALPI_VISIBILE: {},

        PRODUCT_SELECTED: {},

        FILTER_SUBMIT: {},

        FILTER_CHANGE: {},

        FILTER_CHANGE_SMALL: {},

        FILTER_RELOAD_ACTIVATE_LOADER: {},

        FILTER_RELOADED: {},

        FILTER_RESET: {},

        FILTER_MODEL_UPDATE: {},

        FILTER_TOKEN_CHANGED: {},

        FILTER_GROUPS_CLOSE: {},

        FILTER_RELOAD_ERROR: {},

        FILTER_LIMITATION: {},

        FILTER_BECOMES_NON_STICKY: {},

        HITS_RELOAD: {},

        HITS_RELOADED: {},

        HITS_RELOADED_RAW: {},

        HITS_RELOAD_ERROR: {},

        TOGGLE_FILTER_ACCORDION: {},

        TOP_CATEGORIES_RELOADED: {},

        TOP_CATEGORIES_ERROR: {},

        CATEGORY_FILTER_LINK_RELOAD: {},

        OPENED: {}
    },
    RECOMMENDATIONS: {
        ITEM_CHANGED: {} /* Event wird geworfen, wenn die Farbe eines Artikels auf der ADS geändert wird */
    },
    CHECKOUT: {
        OPENED: {}
    },
    WISHLIST_ITEM_CHANGE: {}, /* Wird ausgelöst, wenn bei einem Item change auf der PDP ausgelöst.
                         * - {
                         *      "itemId": Integer,                       // Anzahl hinzugekommener Items
                         *    }
                         */
    FOOTER: {
        REINIT_ACCORDION: {} // used to retrigger the footer accordion
    }
};
